import React from "react";
import { Helmet } from "react-helmet-async";

function Home() {
  return (
    <>
      <Helmet>
        <title>Best Digital Marketing Company in Ajman, Sharjah Dubai, UAE</title>
        <meta
          name="description"
          content="Looking for the best digital marketing company in Dubai? We provide ROI-driven SEO, website development, and digital marketing solutions for every business. Request a quote now."
        />
        <meta
          name="keywords"
          content="best digital marketing company dubai,digital marketing services in ajman,best online digital marketing company in dubai,digital marketing cost in dubai,top digital marketing companies in uae,best digital agencies in abu dhabi,best digital marketing company uae,best digital marketing company abu dhabi,best digital marketing company sharjah,best digital marketing company ajman"
        />
        <link rel="canonical" href="https://www.websiteseo.ae" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Websiteseo",
            url: "https://www.websiteseo.ae/",
            logo: {
              "@type": "ImageObject",
              url: "https://www.websiteseo.ae/images/img/logo.png",
            },
            description:
              "WebsiteSEO is a digital solutions agency offering website design and development, SEO, mobile app development, domain registration, web hosting, social media marketing, email marketing, SMS marketing, branding, and online marketing services to help businesses build and strengthen their digital presence.",
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "Office# 114 Al Ahbabi Building Damascus Street, Al Qusais Dubai, United Arab Emirates",
              addressLocality: "Dubai",
              addressRegion: "Dubai",
              postalCode: "00000",
              addressCountry: "UAE",
            },
            contactPoint: [
              {
                "@type": "ContactPoint",
                telephone: "+971 55 570 9788",
                contactType: "customer service",
                email: "sales@websiteseo.ae",
              },
            ],
          })}
        </script>
      </Helmet>

      {/* HERO */}
      <section
        id="hero"
        className="bg--scroll hero-2 hero-section division0"
        style={{ background: "linear-gradient(-56deg,#aad95d ,#07352b)", paddingTop: 0 }}
      >
        <div className="banner-section" style={{ backgroundImage: "url(/legacy/images/img/web-bg.png)" }}>
          <div className="gradient-background">
            <div className="noise-overlay"></div>
            <div className="particles-container" id="particles-container"></div>
          </div>

          <div className="container">
            <div className="row d-flex align-items-center">
              {/* HERO TEXT */}
              <div className="col-lg-6">
                <div className="hero-2-txt color--white wow animate__animated animate__fadeInRight">
                  <div className="framer-txt-01 ico-20">
                    <a href="#solutions" className="block--shadow">
                      <span className="flaticon-ai color--plum"></span>WebsiteSEO
                    </a>
                  </div>

                  <h1 className="fs-46">
                    Best Digital Marketing Company in Ajman, Abu Dhabi, Sharjah Dubai, UAE
                  </h1>

                  <p className="fs-17">
                    Your vision deserves digital excellence! We deliver it without compromise.
                    We build digital solutions that help you perform, grow faster, and stand out effortlessly.
                  </p>

                  <div className="btns-group">
                    <a href="/contact-us" className="btn btn-md r-08 btn--plum hover--tra-white bgnd-c-grn">
                      Let&apos;s Connect
                    </a>
                  </div>
                </div>
              </div>

              {/* HERO IMAGE */}
              <div className="col-lg-6">
                <div className="box parallaxed p0">
                  <div className="parallaxed p1">
                    <div className="box_burj">
                      <img
                        src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/02ba417f-6eea-457e-7041-c9876cd65200/w=1920,sharpen=1"
                        className="wow animate__animated animate__fadeInLeft"
                        alt="digital marketing services in ajman"
                      />
                    </div>
                  </div>
                  <div className="box_image wd1 parallaxed p2">
                    <img
                      className="wow animate__animated animate__fadeInLeft"
                      src="/legacy/images/img/banner01.png"
                      alt="best online digital marketing company in dubai"
                    />
                  </div>
                  <div className="box_Ave wd2 parallaxed p3">
                    <img
                      src="/legacy/images/img/banner-2.png"
                      className="wow animate__animated animate__fadeInLeft"
                      alt="digital marketing cost in dubai"
                    />
                  </div>
                  <div className="box_rdn wd3 parallaxed p4">
                    <img
                      src="/legacy/images/img/banner-3.png"
                      className="wow animate__animated animate__fadeInRight"
                      alt="best digital agencies in abu dhabi"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* WAVE SHAPE BOTTOM */}
          <div className="wave-shape-bottom fill--white">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 135">
              <path fillOpacity="1" d="M0,96L1440,128L1440,320L0,320Z"></path>
            </svg>
          </div>
        </div>
      </section>

      {/* ABOUT / TEXT CONTENT */}
      <section className="ct-01 content-section division">
        <div className="container">
          <div className="row d-flex align-items-center">
            {/* IMAGE BLOCK */}
            <div className="col-lg-7 order-last order-lg-2">
              <div className="img-block left-column wow animate__animated animate__fadeInRight">
                <img
                  className="img-fluid lt-img"
                  src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/a7a70d0f-9710-421e-e743-db7a85755200/w=1920,sharpen=1"
                  alt="content-image"
                />
              </div>
            </div>

            {/* TEXT BLOCK */}
            <div className="col-lg-5 order-first order-lg-2">
              <div className="txt-block abt-hm right-column wow animate__animated animate__fadeInLeft">
                <span className="module-subtitle subtitle-line">About us</span>
                <h2 className="fs-46">Who we are</h2>
                <p>
                  Your go-to website champions and digital marketing experts! We have brought everything you
                  need to build and maintain a good online presence under one roof — from Website Design and
                  Development to Search Engine Optimization, Social Media Marketing, Email Marketing, and more.
                  With years of experience in the industry, we&apos;re here to turn your challenges into
                  profitable opportunities using the most suitable digital solutions.
                </p>
                <a href="/about-us" className="btn r-08 btn--tra-black hover--plum mt-0">Read more</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <hr className="divider" />

      {/* BRANDS */}
      <div id="brands" className="pt-60 pb-60 brands-1 brands-section division">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10 col-lg-9">
              <div className="brands-title">
                <h6 className="fs-17 fw-500">Trusted by the world&rsquo;s fastest growing companies including:</h6>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col rel">
              <div className="loop_carousel_left">
                {[
                  "5cb55d4b-362c-4b25-af22-704a7118c900",
                  "d90d0535-ad22-47fa-2e6a-60374fd93c00",
                  "4da268e9-bfb1-4eb7-3623-df066f369a00",
                  "16e79490-d8c2-4b56-a13c-b90d8dd06800",
                  "e81edd05-9687-4718-a866-604bc6fdcf00",
                  "36a46888-83ec-4f00-c25e-ba98a7b99b00",
                  "755eee34-eba8-4a15-ed2f-cabca7832d00",
                  "45ded29e-d4ca-48f7-ac76-a0973c035d00",
                  "dd6ce5c0-6d50-4b99-4e53-f1bf4e291000",
                  "2f0f806c-20bb-42d2-5163-4207f7b94f00",
                  "ba0f351d-827f-4370-f67b-0b4ad9503500",
                ].map((id) => (
                  <span className="carousel_slide" key={id}>
                    <a href="#">
                      <img
                        className="lt-img"
                        src={`https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/${id}/w=1920,sharpen=1`}
                        alt="brand-logo"
                      />
                    </a>
                    <a href="#">
                      <img
                        className="dt-img"
                        src={`https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/${id}/w=1920,sharpen=1`}
                        alt="brand-logo"
                      />
                    </a>
                  </span>
                ))}
              </div>
              <div className="carousel_fade white_fade"></div>
              <div className="carousel_fade is-right white_fade"></div>
            </div>
          </div>
        </div>
      </div>

      <hr className="divider" />

      {/* FEATURES / HOW IT WORKS */}
      <section id="how-it-works" className="py-60 features-6 features-section division">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10 col-lg-8">
              <div className="section-title title-01 mb-40">
                <h2 className="fs-25">
                  Your <span className="grdnt-b">One-stop Shop</span> for All Kinds of Website Design &amp;
                  Development Services
                </h2>
                <p className="fs-18 px-35">
                  Looking for a website design/development service that doesn&apos;t break the bank? Trust us
                  for affordable website services and enhance user experience for your visitors. Increase
                  organic traffic on your website, create online shops, and more!
                </p>
              </div>
            </div>
          </div>

          <div className="fbox-wrapper text-center">
            <div className="row">
              <div className="col">
                <div className="owl-carousel owl-theme reviews-carousel">
                  {[
                    {
                      img: "328af584-ed65-401d-2ed6-f2af2ccac500",
                      title: "Website Design",
                      text: "Static & Dynamic websites, Mobile websites, E-commerce websites, and more",
                    },
                    {
                      img: "ab30262d-6422-4af6-0282-fdf7f1c6d600",
                      title: "Mobile Apps",
                      text: "Get your own app with features customized to your unique business needs",
                    },
                    {
                      img: "fee3dc3d-602f-465f-1ae7-3b9e7c30d300",
                      title: "SEO",
                      text: "Rank higher on search engines and boost website traffic organically",
                    },
                    {
                      img: "48ee54e5-5027-4473-082e-b3bb5b3e5900",
                      title: "Email Marketing",
                      text: "Result-oriented email marketing to heighten your chances of success",
                    },
                    {
                      img: "d7876e4f-f00e-48d0-4a1e-5a3b8da59d00",
                      title: "Social Media Marketing",
                      text: "Increase visibility on social media through proven SMM methods",
                    },
                    {
                      img: "882f804c-e9d1-4e8b-22b2-f747c3aca100",
                      title: "SMS Marketing",
                      text: "Connect with direct customers, increase revenue without breaking the bank",
                    },
                  ].map((f) => (
                    <div className="fbox-6 fb-1 wow animate__animated animate__fadeInUp" key={f.title}>
                      <div className="fbox-img h-170 gr--whitesmoke r-12">
                        <img
                          className="img-fluid lt-img"
                          src={`https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/${f.img}/w=1920,sharpen=1`}
                          alt="feature-image"
                        />
                      </div>
                      <div className="fbox-6-txt">
                        <h5 className="fs-19">{f.title}</h5>
                        <p>{f.text}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section
        className="gr--magnolia rel pricing-1 inner-page-hero pricing-section division"
        style={{ background: "linear-gradient(0deg,#ededed ,#ebebeb)" }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10 col-lg-8">
              <div className="section-title title-01 mb-70">
                <h2 className="fs-25">Digital Marketing Bundles</h2>
              </div>
            </div>
          </div>

          {/* DESKTOP PRICING TABLES */}
          <div className="pricing-1-wrapper dn-mob">
            <div className="row d-flex align-items-center row-cols-1 row-cols-md-2 row-cols-lg-3">
              {/* STARTER PLAN */}
              <div className="col">
                <div
                  className="pricing-1-table block--shadow r-12 wow animate__animated animate__fadeInUp animate__delay-1"
                  style={{ backgroundImage: "url(/legacy/images/img/bg-price-1.webp)", backgroundSize: "cover", backgroundPosition: "right" }}
                >
                  <div className="pricing-table-header">
                    <h6 className="fs-20">Bundle</h6>
                    <div className="price">
                      <span className="color--header"> 3<span className="fn-itlc"> in </span>1 </span>
                    </div>
                  </div>
                  <hr />
                  <div className="price">
                    <ul className="list-icns">
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best digital marketing company abu dhabi" /> Email Marketing</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best digital marketing company uae" /> Social Media Marketing</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best digital marketing company ajman" /> SMS Marketing</li>
                    </ul>
                  </div>
                  <a href="/contact-us" className="pt-btn btn r-08 btn--tra-black hover--blue">Get started now</a>
                </div>
              </div>

              {/* BASIC / HIGHLIGHTED PLAN */}
              <div className="col">
                <div
                  className="pricing-1-table highlight border--blue block--shadow r-12 wow animate__animated animate__fadeInUp animate__delay-2"
                  style={{ backgroundImage: "url(/legacy/images/img/bg-price-1.webp)", backgroundSize: "cover", backgroundPosition: "right" }}
                >
                  <div className="badge-wrapper">
                    <div className="highlight-badge bg--blue color--white">
                      <h6>Perfect choice for you</h6>
                    </div>
                  </div>
                  <div className="pricing-table-header">
                    <h6 className="fs-20">Bundle</h6>
                    <div className="price">
                      <div className="price2">
                        <span className="color--header"> 4<span className="fn-itlc"> in </span>1 </span>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="price">
                    <ul className="list-icns">
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best digital marketing company uae" /> SEO (Search Engine Optimization)</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="top digital marketing companies in uae" /> Email Marketing</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best online digital marketing company in dubai" /> Social Media Marketing</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best digital marketing company uae" /> SMS Marketing</li>
                    </ul>
                  </div>
                  <a href="/contact-us" className="pt-btn btn r-08 btn--blue hover--black">Get started now</a>
                </div>
              </div>

              {/* ADVANCED PLAN */}
              <div className="col">
                <div
                  className="pricing-1-table block--shadow r-12 wow animate__animated animate__fadeInUp animate__delay-3"
                  style={{ backgroundImage: "url(/legacy/images/img/bg-price-1.webp)", backgroundSize: "cover", backgroundPosition: "right" }}
                >
                  <div className="pricing-table-header">
                    <h6 className="fs-20">Bundle</h6>
                    <div className="price">
                      <div className="price2">
                        <span className="color--header"> 5<span className="fn-itlc"> in </span>1 </span>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="price">
                    <ul className="list-icns">
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best digital marketing company dubai" /> Website Design</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="digital marketing services in ajman" /> SEO (Search Engine Optimization)</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="digital marketing cost in dubai" /> Email Marketing</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="top digital marketing companies in uae" /> Social Media Marketing</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best digital marketing company abu dhabi" /> SMS Marketing</li>
                      <li><em>All your digital needs covered!</em></li>
                    </ul>
                  </div>
                  <a href="/contact-us" className="pt-btn btn r-08 btn--tra-black hover--blue">Get started now</a>
                </div>
              </div>
            </div>
          </div>

          {/* MOBILE PRICING CAROUSEL */}
          <div className="col package-mob db-mob">
            <div className="owl-carousel owl-theme reviews-carousel">
              <div className="col1">
                <div
                  className="pricing-1-table block--shadow r-12 wow animate__animated animate__fadeInUp animate__delay-1"
                  style={{ backgroundImage: "url(/legacy/images/img/bg-price-1.webp)", backgroundSize: "cover", backgroundPosition: "right" }}
                >
                  <div className="pricing-table-header">
                    <h6 className="fs-20">Bundle</h6>
                    <div className="price">
                      <span className="color--header"> 3<span className="fn-itlc"> in </span>1 </span>
                    </div>
                  </div>
                  <hr />
                  <div className="price1">
                    <ul className="list-icns1">
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best digital marketing company sharjah" /> Email Marketing</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="digital marketing cost in dubai" /> Social Media Marketing</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best online digital marketing company in dubai" /> SMS Marketing</li>
                    </ul>
                  </div>
                  <a href="/contact-us" className="pt-btn btn r-08 btn--tra-black hover--blue">Get started now</a>
                </div>
              </div>

              <div className="col1">
                <div
                  className="pricing-1-table block--shadow r-12 wow animate__animated animate__fadeInUp animate__delay-3"
                  style={{ backgroundImage: "url(/legacy/images/img/bg-price-1.webp)", backgroundSize: "cover", backgroundPosition: "right" }}
                >
                  <div className="pricing-table-header">
                    <h6 className="fs-20">Bundle</h6>
                    <div className="price">
                      <div className="price2">
                        <span className="color--header"> 4<span className="fn-itlc"> in </span>1 </span>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="price1">
                    <ul className="list-icns1">
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best digital marketing company uae" /> SEO (Search Engine Optimization)</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="digital marketing cost in dubai" /> Email Marketing</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best digital marketing company ajman" /> Social Media Marketing</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best digital agencies in abu dhabi" /> SMS Marketing</li>
                    </ul>
                  </div>
                  <a href="/contact-us" className="pt-btn btn r-08 btn--blue hover--black">Get started now</a>
                </div>
              </div>

              <div className="col1">
                <div
                  className="pricing-1-table block--shadow r-12 wow animate__animated animate__fadeInUp animate__delay-3"
                  style={{ backgroundImage: "url(/legacy/images/img/bg-price-1.webp)", backgroundSize: "cover", backgroundPosition: "right" }}
                >
                  <div className="pricing-table-header">
                    <h6 className="fs-20">Bundle</h6>
                    <div className="price">
                      <div className="price2">
                        <span className="color--header"> 5<span className="fn-itlc"> in </span>1 </span>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="price1">
                    <ul className="list-icns1">
                      <li><img src="/legacy/images/img/list-arow.svg" alt="digital marketing services in ajman" /> Website Design</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="top digital marketing companies in uae" /> SEO (Search Engine Optimization)</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best digital marketing company uae" /> Email Marketing</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best digital marketing company sharjah" /> Social Media Marketing</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best digital marketing company abu dhabi" /> SMS Marketing</li>
                      <li><em style={{ fontSize: "13px", marginTop: "15px" }}>All your digital needs covered!</em></li>
                    </ul>
                  </div>
                  <a href="/contact-us" className="pt-btn btn r-08 btn--tra-black hover--blue">Get started now</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* INTEGRATIONS / BOOST BUSINESS */}
      <section id="integrations" className="pt-80 pb-80 bc-02 ws-wrapper content-section offer-1">
        <div className="container">
          <div className="pb-80">
            <div className="row d-flex align-items-center">
              <div className="col-lg-6 order-2 order-md-1">
                <div className="txt-block left-column wow animate__animated animate__fadeInLeft">
                  <h2 className="fs-25">Boost Your Business with a Fully Functional Website</h2>

                  <h6 className="mb-1"><img src="/legacy/images/img/list-arow.svg" width="25" alt="best digital agencies in abu dhabi" /> Domain</h6>
                  <p>Domain registration made easy</p>

                  <h6 className="mb-1"><img src="/legacy/images/img/list-arow.svg" width="25" alt="best digital marketing company abu dhabi" /> Hosting</h6>
                  <p>Reliable web hosting services for your business website</p>

                  <h6 className="mb-1"><img src="/legacy/images/img/list-arow.svg" width="25" alt="best digital marketing company uae" /> Website Design &amp; Development</h6>
                  <p>Your key to excellent brand visibility and online presence</p>
                </div>
              </div>
              <div className="col-lg-6 order-1 order-md-2 pdg-b">
                <img
                  src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/cbfdb099-c754-4b4b-0622-44926cee2900/w=1920,sharpen=1"
                  width="100%"
                  alt="best digital marketing company uae"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="offer-2">
            <div className="row d-flex align-items-center">
              <div className="col-lg-6">
                <img
                  src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/c5698339-8e73-4cc9-ea41-6a8875778900/w=1920,sharpen=1"
                  width="100%"
                  alt="best digital marketing company sharjah"
                />
              </div>
              <div className="col-lg-6">
                <div className="txt-block right-column wow animate__animated animate__fadeInLeft" style={{ padding: "0 25px" }}>
                  <h2 className="fs-25">WebsiteSeo.ae <br />for Foolproof Websites</h2>
                  <div className="list-flx">
                    <ul className="list-icns">
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best digital marketing company sharjah" /> Budget Websites</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best online digital marketing company in dubai" /> 99.9% Uptime Guarantee</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="digital marketing cost in dubai" /> Advanced Security Scan</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best digital agencies in abu dhabi" /> cPanel Control Panel</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best digital marketing company uae" /> One FREE Domain for Life</li>
                    </ul>
                    <ul className="list-icns">
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best digital marketing company sharjah" /> Host Unlimited Domains</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="digital marketing services in ajman" /> FREE Website Transfer</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best online digital marketing company in dubai" /> Unlimited Disk Space</li>
                      <li><img src="/legacy/images/img/list-arow.svg" alt="best digital marketing company abu dhabi" /> 24x7/365 Support</li>
                    </ul>
                  </div>

                  <p className="slit-gdnt mt-1">
                    <span className="count-element">1000</span><small></small> Websites Designed and Hosted
                  </p>

                  <p>Get Your Business Online Today!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section id="reviews" className="reviews-1 reviews-section division">
        <div className="reviews-1-wrapper">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-8">
                <div className="section-title title-01 mb-70">
                  <h2 className="fs-25">Hear it from Our Customers</h2>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <div className="owl-carousel owl-theme reviews-carousel">
                  {[
                    {
                      name: "Vijay Kapur (Director)",
                      company: "Dewdrops Nursery Group",
                      text: "WebsiteSEO.ae has a can-do attitude and do their best to deliver what they promise. They are accessible and flexible which is very important in the type of services they provide. Being a nursery, our requirements were different from their other clients and they were innovative in their approach.",
                      stars: 5,
                    },
                    {
                      name: "- Mohammad Khalid (GM)",
                      company: "Shanco Contracting L.L.C",
                      text: "We are glad that you have made our website & are providing very well technical support, we therefor request you to keep the same service support in the near future as well.",
                      stars: 5,
                    },
                    {
                      name: "Mr. Gurpreet S Bahra",
                      company: "Pan Intellecom DMCC",
                      text: "I've known Sharib for the last 8 years and seen his dedication and sincerity towards his work and if I have problem in my outgoing emails during my various travels to other countries he assists even after the office hours. This is the real 24/7 support",
                      stars: 4.5,
                    },
                    {
                      name: "Catherine",
                      company: "",
                      text: "As a businessman I don't need ONLY beautiful display, I also need flawless transaction on my website and I got it both. Creative design, user and admin friendly website. Thank you websiteseo.com team for the job well done.",
                      stars: 4.5,
                    },
                    {
                      name: "John",
                      company: "",
                      text: "Online shop in UAE is a huge challenge for beginners in the field. As a one man business I need a help to introduce my company in the market, then a friend refer Sharib for online marketing (SEO, SMS & E-mail marketing, Social Media marketing) and now I don't need to hire a sales & marketing team to work for me. Business is running well. Thank you!",
                      stars: 4,
                    },
                  ].map((r) => (
                    <div className="review-1 bg--white block--shadow r-08" key={r.name}>
                      <div className="review-source">
                        <img src="/legacy/images/img/qt.png" alt="logo" />
                      </div>
                      <div className="author-data mb-15 clearfix">
                        <div className="review-author">
                          <h6 className="fs-16">{r.name}</h6>
                          <p className="fs-15">{r.company}</p>
                        </div>
                      </div>
                      <div className="review-txt">
                        <p>{r.text}</p>
                      </div>
                      <div className="review-rating ico-15 color--yellow mt-15">
                        {Array.from({ length: Math.floor(r.stars) }).map((_, i) => (
                          <span className="flaticon-star" key={i}></span>
                        ))}
                        {r.stars % 1 !== 0 && <span className="flaticon-star-half-empty"></span>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
